import { h } from 'vue';
import styles from './index.module.scss';
import { utility } from '..';

export function LoadingIndicator(hidden: boolean) {
    return h('svg', {
        viewBox: '0 0 64 49',
        version: '1.1',
        class: {
            [styles.indicator]: true,
            [utility.block]: !hidden,
            [utility.hidden]: hidden,
        },
    }, [
        h('circle', {
            class: [styles.one, styles.circle],
            cx: '12',
            cy: '29',
            r: '6',
        }),

        h('circle', {
            class: [styles.two, styles.circle],
            cx: '32',
            cy: '29',
            r: '6',
        }),

        h('circle', {
            class: [styles.three, styles.circle],
            cx: '52',
            cy: '29',
            r: '6',
        }),
    ]);
}
